// https://usehooks.com/useScript/
import { useEffect } from 'react';
import { useState }  from 'react';

const cachedScripts = [];
export default function useScript(src) {
  // keeping track of script loaded and error state
  const [ state, setState ] = useState({
    loaded: false,
    error:  false
  });

  useEffect(() => {
    // if cachedScripts array already includes src that means another instance
    // of this hook already loaded this script, so no need to load again.
    if (cachedScripts.includes(src)) {
      setState({
        loaded: true,
        error:  false
      });
      return () => {};

    } else {
      cachedScripts.push(src);

      const script = document.createElement('script');
      script.src   = src;
      script.async = true;

      script.onload = () => {
        setState({
          loaded: true,
          error:  false
        });
      };

      script.onerror = () => {
        // remove from cachedScripts we can try loading again
        const index = cachedScripts.indexOf(src);
        if (index >= 0)
          cachedScripts.splice(index, 1);
        script.remove();

        setState({
          loaded: true,
          error:  true
        });
      };

      document.body.appendChild(script);
      return () => {
        script.onload  = () => {};
        script.onerror = () => {};
        document.body.removeChild(script);
      };
    }
  }, [ src ]);

  return [ state.loaded, state.error ];
}
